const MS_IN_SECOND = 1000
const HOUR_IN_SECONDS = 3600
const HOUR_IN_MS = 3600000

export function subtractSecondsFromNow(seconds?: number): Date {
  const now = new Date()

  if (seconds) {
    const past = new Date(now.getTime() - seconds * MS_IN_SECOND)
    return past
  }
  return now
}

/**
 * Subtracts a specified number of hours from the current time and returns a Date object.
 *
 * @param hours - Number of hours to subtract from now. Pass `1` to subtract 1 hour.
 * @returns Date - A Date object representing the time after subtracting the specified hours.
 */
export function subtractHoursFromNow(hours?: number): Date {
  const now = new Date()

  if (hours) {
    const past = new Date(now.getTime() - hours * HOUR_IN_MS)
    return past
  }
  return now
}

/**
 * Subtracts a specified number of hours from the current time and returns the result in seconds since the epoch.
 *
 * @param hours - Number of hours to subtract from now. Pass `1` to subtract 1 hour.
 * @returns number - The time, in seconds since the Unix epoch, after subtracting the specified hours.
 */
export function subtractHoursFromNowInSeconds(hours?: number): number {
  const now = Math.floor(new Date().getTime() / MS_IN_SECOND)

  if (hours) {
    const past = now - hours * HOUR_IN_SECONDS
    return past
  }
  return now
}
